import styled from "styled-components";

export const Container = styled.div`
  .tab {
    background-color: #ffffff;
    padding: 0.5rem 1rem;
    margin-bottom: 4rem;
  }
`;
